<!-- <div class="nb-theme-default"> -->
<input [type]="type" nbInput fullWidth [placeholder]="placeholder" [fieldSize]="size" [shape]="shape" [status]="status" (change)="sendInput($event)">
<!-- </div> -->
